import React, { useEffect, useMemo, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import closeIcon from '../../assets/images/closeIcon.svg';
import FilledButton from '../../components/Buttons/FilledButton';
import FolderTreeSelector from '../../components/FolderTreeSelector';
import classes from './styles.module.scss';

export default function FolderPickerModal({
  show,
  onHide,
  onSelect,
  title = 'Select destination folder',
  subtitle = 'Choose where the video created from this template should be saved.',
  confirmLabel = 'Use template',
}) {
  const [selectedFolderId, setSelectedFolderId] = useState(null);
  const [resourceNames, setResourceNames] = useState({});

  useEffect(() => {
    if (show) {
      setSelectedFolderId(null);
      setResourceNames({});
    }
  }, [show]);

  const selectedFolderName = useMemo(() => {
    if (!selectedFolderId) {
      return null;
    }

    return resourceNames[selectedFolderId] || null;
  }, [resourceNames, selectedFolderId]);

  const handleSelect = () => {
    if (!selectedFolderId) {
      return;
    }

    onSelect(selectedFolderId, selectedFolderName);
    onHide();
  };

  const handleClose = () => {
    setSelectedFolderId(null);
    setResourceNames({});
    onHide();
  };

  return (
    <Modal
      show={show}
      centered
      contentClassName={classes.FolderPickerModal}
      dialogClassName={classes.dialog}
      backdropClassName={classes.backdrop}
      onHide={handleClose}
    >
      <i
        className={classes.closeIcon}
        onClick={handleClose}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleClose();
          }
        }}
      >
        <img src={closeIcon} alt="Close" />
      </i>
      <div className={classes.content}>
        <h2>{title}</h2>
        <p className={classes.subtitle}>{subtitle}</p>
        <div className={classes.selectionInfo}>
          <span className={classes.selectionLabel}>Selected folder:</span>
          <span className={classes.selectionValue}>
            {selectedFolderName || 'Not selected'}
          </span>
        </div>
        <div className={classes.treeContainer}>
          <FolderTreeSelector
            showCheckboxes={false}
            showMeetings={false}
            showRoot={false}
            selectedFolderId={selectedFolderId}
            onFolderSelect={setSelectedFolderId}
            onResourceNamesUpdate={(entries) => {
              setResourceNames((prev) => ({
                ...prev,
                ...entries,
              }));
            }}
          />
        </div>
        <div className={classes.actions}>
          <FilledButton
            width={180}
            isDisabled={!selectedFolderId}
            onClick={handleSelect}
            style={{ whiteSpace: 'nowrap' }}
          >
            {confirmLabel}
          </FilledButton>
        </div>
      </div>
    </Modal>
  );
}
